module.exports = __webpack_public_path__ + "static/media/sia-orange.2827df84.png";